/**
 * @desc 全局设置
 */
const isOfficial = process.env.VUE_APP_STATUS === 'official';
export const domain = isOfficial ? '123cx.com' : 'cxyun-test.com';
export const dotDomain = `.${domain}`;
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsOD0oHb007bxLJwjkMZA5N44eZ3xUxm89jnHgpmP8Cy1+5b8gKWOiVMkHB4WAn2eblciwevpGNJH80b9G0ic52Shr5FlzOzek55NN24CSaTFNMjVFHkt6KtdUnGYanvyFVlRzwX119Oii7YQHhNYPSl6Zqk2I+N5gTkmtvpCJRQIDAQAB';
export const baseUrl = `//apiswise${dotDomain}`;
export const baseUrl1 = `//authwise${dotDomain}`;
export const baseUrl2 = `//apiswise${dotDomain}`;
export const vendorUrl = process.env.VUE_APP_STATUS === 'official' ? '//fed-static.123cx.com/vendor' : `//wisetest${dotDomain}/itbus2.5/vendor`;
export const componentUrl = process.env.VUE_APP_STATUS === 'official' ? '//fed-static.123cx.com/components' : `//wisetest${dotDomain}/itbus2.5/components`;
export const moduleUrl = `${location.pathname.slice(0, -1)}/modules`;
export const wsUrl = `//socket4${dotDomain}/pull_data`;
export default {vendorUrl, componentUrl, moduleUrl, publicKey, baseUrl, wsUrl};
